/** Dispatched when FO health probe transitions to online (API reachable). */
export const API_ONLINE_EVENT = 'incashflow:api-online';

export function dispatchApiOnline(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(API_ONLINE_EVENT));
}

/** Whether an offline cashier session should refresh tokens after API recovery. */
export function shouldPromoteOfflineSession(opts: {
  sessionMode?: 'online' | 'offline';
  hasRefreshToken: boolean;
  apiOnline: boolean;
}): boolean {
  return (
    opts.apiOnline === true &&
    opts.sessionMode === 'offline' &&
    opts.hasRefreshToken === true
  );
}

/**
 * Detect false→true API connectivity transitions so callers can promote
 * offline sessions even when `navigator.onLine` never flipped.
 */
export function didRecoverApiConnectivity(
  previouslyOnline: boolean,
  currentlyOnline: boolean,
): boolean {
  return currentlyOnline === true && previouslyOnline === false;
}
